/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import Accordion from '@ion/dls/src/components/accordion/ExpansionPanel';
import {
  LayerSettingsHeader,
  LayerSettingsProps,
  LayerSettingsStyles
} from './LayerSettings';

// defines the styles used by the ThirdpartyLayerSettings
const useStyles = makeStyles(theme => (LayerSettingsStyles()));

/**
 * @SubLayers
 *
 * Defines the SubLayers Tab / Section of the ThirdpartyLayerSettings
 */
const SubLayers = () => {};

/**
 * @Legend
 *
 * Defines the Legend Tab / Section of the ThirdpartyLayerSettings
 */
const Legend = () => {};

// defines the unique identifier for the ThirdpartyLayerSettings
export const THIRD_PARTY_LAYER = 'thirdParty';

/**
 * @ThirdpartyLayerSettings
 *
 * The Thirdparty Layer Settings provides a component which allows users to select
 * specific Thirdparty layer related attributes to be displayed within a DLSMap.
 *
 * The ThirdpartyLayerSettings component represents the "Thirdparty Layers" DLS feature:
 * https://www.figma.com/file/srjlHrDuM90sCoaOwpjaDU/01_DLS_Components?node-id=1904%3A13962
 *
 * ```typescript
 *
 *   <ThirdpartyLayerSettings onToggle={}
 *     isEnabled={}
 *     map={} />
 *
 * ```
 */
export const ThirdpartyLayerSettings = ({
  map,
  isEnabled,
  onToggle
}: LayerSettingsProps) => {
  const classes: any                = useStyles();
  const [defaultLayer, setSelected] = useState(isEnabled);
  const label                       = translate('maps:thirdParty.header');

  const onToggleLayer = function({target}) {
    setSelected(target.checked);
    onToggle(THIRD_PARTY_LAYER, target.checked);
  };

  const Details = (<div />);

  return (
    <div className={classes.root}>
      <Grid container direction='row'>
        <Grid item xs={12} md={12}>
          <Paper className={classes.paper}>
            <Accordion children=''
              id={label}
              header={<LayerSettingsHeader label={label}
                defaultLayer={defaultLayer}
                onToggle={onToggleLayer} />} details={Details}
              detailsRootOverride={classes.accordionDetails} />
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default ThirdpartyLayerSettings;
